import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Typography from "../components/Typography";
import { spacing } from "../utils/tokens";
import { useTheme } from "../context/ThemeContext";

import "./BottomTabNav.css";

// Import Phosphor icons
import { List, ChartBar, SlidersHorizontal, Play, DotsNine } from "@phosphor-icons/react";

import Divider from "./Divider";

const loadIcons = () => ({
  today: {
    default: require("../assets/nav-icons/Today.svg").default,
    active: require("../assets/nav-icons/Today-fill.svg").default,
  },
  markets: {
    default: require("../assets/nav-icons/Markets.svg").default,
    active: require("../assets/nav-icons/Markets-fill.svg").default,
  },
  mywsj: {
    default: require("../assets/nav-icons/MyWSJ.svg").default,
    active: require("../assets/nav-icons/MyWSJ-fill.svg").default,
  },
  media: {
    default: require("../assets/nav-icons/Media.svg").default,
    active: require("../assets/nav-icons/Media-fill.svg").default,
  },
  more: {
    default: require("../assets/nav-icons/More.svg").default,
    active: require("../assets/nav-icons/More-fill.svg").default,
  },
});

function BottomTabNav() {
  const location = useLocation();
  const { theme } = useTheme();
  const [icons, setIcons] = useState({});

  // const tabs = [
  //   { label: "Today", path: "/", icon: TodayIcon, iconActive: TodayIconFill },
  //   { label: "Markets", path: "/markets", icon: MarketsIcon, iconActive: MarketsIconFill },
  //   { label: "MyWSJ", path: "/mywsj", icon: MyWSJIcon, iconActive: MyWSJIconFill },
  //   { label: "Media", path: "/media", icon: MediaIcon, iconActive: MediaIconFill },
  //   { label: "More", path: "/more", icon: MoreIcon, iconActive: MoreIconFill },
  // ];

  useEffect(() => {
    setIcons(loadIcons());
  }, []);

  const tabs = [
    { label: "Today", path: "/", key: "today" },
    { label: "Markets", path: "/markets", key: "markets" },
    { label: "MyWSJ", path: "/mywsj", key: "mywsj" },
    { label: "Media", path: "/media", key: "media" },
    { label: "More", path: "/more", key: "more" },
  ];

  const styles = {
    navContainer: {
      position: "fixed",
      bottom: 0,
      display: "flex",
      width: "100%",
      height: "86px",
      justifyContent: "space-around",
      alignItems: "flex-start",
      backgroundColor: theme.colors.background,
      borderTop: `1px solid ${theme.colors.borderSecondary}`,
      padding: "8px 0",
      zIndex: 1000,
    },
    tab: {
      display: "flex",
      flexDirection: "column",
      gap: spacing.xs,
      alignItems: "center",
      textDecoration: "none",
      color: theme.colors.contentSecondary,
      margin: "4px 0",
    },
    activeTab: {
      color: theme.colors.contentPrimary,
    },
    icon: {
      width: "24px",
      height: "24px",
    }
  };


  return (
    <nav className="bottom-nav-container" style={styles.navContainer}>
      {tabs.map((tab) => {
        // console.log("Tab Key: " + tab.path);
        // console.log("location pathname " + location.pathname);
        const isActive = tab.path === "/" ? location.pathname === "/" : location.pathname.startsWith(tab.path);
        const iconSrc = icons[tab.key] ? (isActive ? icons[tab.key].active : icons[tab.key].default) : null;

        return (
          <Link
            key={tab.label}
            to={tab.path}
            style={{
              ...styles.tab,
              ...(isActive ? styles.activeTab : {}),
            }}
          >
            {/* {getIcon(tab.icon, isActive)} */}
            {iconSrc ? <img src={iconSrc} alt={tab.label} style={styles.icon} loading="eager" /> : <div style={{ width: "24px", height: "24px" }} />}
            <div className={isActive?"isActive":""}>
            <Typography className="nav-bottom-button" variant="button" type="utility">{tab.label}</Typography>
            </div>
          </Link>
        );
      })}
    </nav>
  );
}

export default React.memo(BottomTabNav);
